import React, { Component, PropTypes } from 'react';

export default class CheckBox extends Component {
	static propTypes = {
		handleChange: PropTypes.func.isRequired,
		id: PropTypes.string.isRequired,
		name: PropTypes.string,
		value: PropTypes.string,
		checked: PropTypes.bool.isRequired,
		required: PropTypes.bool,
		disabled: PropTypes.bool,
		qaSelector: PropTypes.string
	};
	static defaultProps = {
		required: false,
		disabled: false
	};
	render() {
		const { id, value, checked, handleChange, required, disabled, qaSelector, name } = this.props;

		return (
			<input
				id={id}
				name={name || id}
				type="checkbox"
				checked={checked}
				value={value}
				data-qa={qaSelector}
				className="dna-checkbox"
				onChange={handleChange}
				required={required}
				disabled={disabled} />
		);
	}
}



// WEBPACK FOOTER //
// ../~/dna-form/components/checkbox/CheckBox.jsx